import React, { Component } from 'react';
import Dfp from './Dfp';

class Nav extends Component {
	constructor(){
		super();

		this.state = {
			lastScrollTop:0
		}

		this.menuToggle = this.menuToggle.bind(this);
		this.renderLogo = this.renderLogo.bind(this);
		this.handleScroll = this.handleScroll.bind(this);
	}
	menuToggle(evnt){
		if(document.getElementById('menu-nav')){
			let elm = document.getElementById('menu-nav');
			if(elm.className.indexOf('open')<0){
				document.getElementById('menu-nav').className = 'open';
			}else{
				let tmpElm = document.querySelectorAll('.open')
				for(let i =0; i<tmpElm.length;i++){
					tmpElm[i].className = tmpElm[i].className.replace('open','');
				}
			}
		}
	}

	componentWillUnmount(){
		window.removeEventListener('scroll', this.handleScroll);
	}


	componentDidMount(){
		window.addEventListener('scroll', this.handleScroll);
		document.querySelector('.search-btn-close').onclick = this.searchToggle;
		document.getElementById('nav-branding').onclick = this.showMenu;
	}

	showMenu(){
		let elm = document.querySelectorAll('.down');
		for(let i=0; i< elm.length; i++){
			elm[i].className = elm[i].className.replace(' down','');
		}
	}

	handleScroll(evnt){
		const { lastScrollTop } = this.state;

		const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
		const st = window.pageYOffset;
		const elms = document.querySelectorAll('.nav-logo');
		const navBound = document.querySelector('.nav-bound-wrapper');
		const navBranding = document.getElementById('nav-branding');

		if (scrollTop === 0) {
			for (let k = 0; k < elms.length; k++) {
				elms[k].className = elms[k].className.replace(' down','') + ' deadown';
			}
			navBound.className = navBound.className.replace(' down','') + ' deadown';
			navBranding.className = navBranding.className.replace(' down','') + ' deadown';
		}else if (scrollTop > document.querySelector('.nav-logo').getBoundingClientRect().height/3){
			for (let k=0; k<elms.length; k++) {
				if(st > lastScrollTop){
					//elms[k].className = elms[k].className.replace(' deadown','');
					//navBound.className = navBound.className.replace(' deadown','');
					//navBranding.className = navBranding.className.replace(' deadown','');
					elms[k].className = elms[k].className.replace(' down','') + ' down';
					navBound.className = navBound.className.replace(' down','') + ' down';
					navBranding.className = navBranding.className.replace(' down','') + ' down';
				}else{
					elms[k].className = elms[k].className.replace(' deadown','');
					navBound.className = navBound.className.replace(' deadown','');
					navBranding.className = navBranding.className.replace(' deadown','');
					elms[k].className = elms[k].className.replace(' down','');
					navBound.className = navBound.className.replace(' down','');
					navBranding.className = navBranding.className.replace(' down','');
				}
			}
			this.setState({ lastScrollTop:st });
		}
	}

	searchToggle(){
		let elm = document.getElementById('nav-search');

		if(elm.className.indexOf('open')<0){
			elm.className = 'open';
		}else{
			elm.className = '';
		}
	}

	renderLogo(item){
		const { catId } = this.props
		let tmp = '';

		if(catId==0){
			tmp = <div id="shecom-logo"></div>
		}else if(catId==7287 || catId==7289 || catId==7339 || catId==7338){
			tmp = <div id="shecom-category-logo">
				<a href="/"><div className="nestlemomme-logo"></div></a>
				<div className="Raleway text-center catTitle nestle" style={{ color: item.category_title_color }}>{ item.title }</div>
			</div>
		}else{
			tmp = <div id="shecom-category-logo">
				<a href="/"><div className="shelogo"></div></a>
				<div className="Raleway text-center catTitle" style={{ color: (document.querySelector('meta[name="baseURL"]').content.indexOf('.shemom.com') != -1) ? '#5a4441' : item.category_title_color }}>{ item.title }</div>
			</div>
		}

		return tmp;
	}

	render(){
		const { menudata,theme, catId, postId } = this.props
		let menuList = [];
		let tmpItem = '';
		let mainmenu = '';

		if(catId==0){
			menuList = menudata;
			mainmenu = "shemainmenu";
		}
		else{
			for(let i=0; i<menudata.length; i++){
				if(menudata[i].object_id == catId ){
					menuList = ( menudata[i].hasOwnProperty('child') ? menudata[i].child : menudata);
					tmpItem = menudata[i];
					break;
				}
				else{
					if(menudata[i].hasOwnProperty('child')){
						for(let k=0; k <menudata[i].child.length; k++){
							if(menudata[i].child[k].object_id == catId){
								menuList = menudata[i].child;
								tmpItem = menudata[i];
								break;
							}
						}
					}else if(menudata[i].object_id == postId){
							menuList = ( menudata[i].hasOwnProperty('child') ? menudata[i].child : menudata);
							tmpItem = menudata[i];
							break;
					}
				}
			}
		}

		return (
			<header className="deadown">
				<nav style={{ backgroundImage:( tmpItem.cover_image ? 'url('+tmpItem.cover_image+')' : '') }} className={mainmenu}>
					<div id="nav-branding" className=" deadown"></div>
					<div className="nav-logo text-center deadown">
						<div className="fullfill">
							<div className="ctable">
								<div className="ctable-cell">
									{ this.renderLogo(tmpItem) }
								</div>
							</div>
							<div className="btn-menu-mobile" onClick={this.menuToggle}>
								<i className="icon-menu-01"></i>
							</div>
							<div id="btn-search-mobile" className="right" onClick={this.searchToggle}>
								<i className="icon-search-01"></i>
							</div>
						</div>
					</div>
					<div className="nav-bound-wrapper deadown">
						<div className="nav-bound">
							<div className="btn-menu" onClick={this.menuToggle}>
								<i className="icon-menu-01"></i>
							</div>
							<div className="nav-ads">
								<Dfp
									adUnit={ theme+'_nav_ROS_150x30' }
									sizes={[[150,30],[150,42]]}
								/>
							</div>
							{
								menuList.map(function(menuItem,idex){
									if (menuItem.title == 'sheshops'){
										return (
											<a className="Abel home sheshop" rel='noopener' href={menuItem.url} target={menuItem.target} key={idex}>{menuItem.title} <span class="sheshopbtn">New</span></a>
										)
									}else if(menuItem.title == 'Nestlé MOM&me' || menuItem.title == 'BB長肉有計' || menuItem.title == 'BB健康長肉' || menuItem.title == '雀巢能恩全護INFINIPRO4專區'){
										return(
											<a className="Abel home nestle" rel='noopener' href={menuItem.url} target={menuItem.target} key={idex}>{menuItem.title}</a>
											)
									}else{
										return (

											<a className="Abel home" rel='noopener' href={menuItem.url} target={menuItem.target} key={idex}>{menuItem.title}</a>
										)
									}

								})
							}
						<div id="btn-search" className="right" onClick={this.searchToggle}>
							<i className="icon-search-01"></i>
						</div>
						</div>
						<div className="cat-shutter-left"></div>
						<div className="cat-shutter-right"></div>
					</div>
					<div id="loading-bar" className="done">
						<span id="modal-bit-loader" className="modal-pulsate" style={{ background:tmpItem.category_title_color }} ></span>
					</div>
				</nav>
			</header>
		)
	}
}

export default Nav



// WEBPACK FOOTER //
// ./src/Nav.js